import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import store from "./store";
import { Provider } from 'react-redux';
import './i18n';
import { MsalProvider } from "@azure/msal-react";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from './authConfig';
import ErrorBoundary from "ErrorBoundary";
const root = ReactDOM.createRoot(document.getElementById("root"));
const theme = createTheme({
  typography: {
    headerName: {
      fontSize: '1.5rem',
      color: '#F8F8F8',
    },
  },
});

let initialBasename = 'Agri360';

const msalInstance = new PublicClientApplication(msalConfig);

const MainApp = () => {
  const [basename, setBasename] = useState(initialBasename);

  useEffect(() => {
    const changeBasename = () => {
      if (process.env.REACT_APP_BRANCH) {
        setBasename(prev => `${prev}${process.env.REACT_APP_BRANCH}`);
      }
    };

    changeBasename();
  }, []);

  return (
    <BrowserRouter basename={basename}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

root.render(
  <ErrorBoundary>
    <MainApp />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
